/**
 * Samtycke till behandling av särskilda kategorier av personuppgifter — the
 * standalone variant. Same approved text as the bilaga (§§ 1–8 shared), but
 * its own contract in "Övriga avtal", signed by hyresgäst and hyresvärd via
 * Scrive. Requires the samtycke_sarskilda_bilaga blocks in the registry.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { signingPartiesFor } from '../common/index.js';
import { letterheadAndFooter } from './personuppgiftsbilaga.js';
import { SAMTYCKE_DESCRIPTION, SAMTYCKE_PREAMBLE, SAMTYCKE_STATUTE, SAMTYCKE_TITLE, samtyckeSharedBody, } from './samtycke_sarskilda_bilaga.js';
const FORM_NUMBER = 'Formulär R-24';
const PARTY_SLOTS = [
    { id: 'lessee', label: 'Hyresgäst', role: 'lessee', ordinal: 0, required: true, signs: true },
    { id: 'lessor', label: 'Hyresvärd', role: 'lessor', ordinal: 0, required: true, signs: true },
];
const META = {
    category: 'Övriga avtal',
    shortTitle: 'Samtycke särskilda kategorier',
    formNumber: FORM_NUMBER,
    preamble: SAMTYCKE_PREAMBLE,
    description: SAMTYCKE_DESCRIPTION +
        '\n\nVem undertecknar: hyresgästen och hyresvärden. Skickas via Scrive.\n\n' +
        'Ska samtycket i stället bifogas ett hyresavtal och signeras tillsammans med det — använd bilagan "Samtycke särskilda kategorier (bilaga)" från avtalets Bilagor-flik i stället.',
    statute: SAMTYCKE_STATUTE,
    signingMode: 'digital',
    signingPlacementAnchors: 'per-party-label',
    numberStyle: 'paragraph',
    partySlots: PARTY_SLOTS,
};
export const samtyckeSarskildaAvtalV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'samtycke_sarskilda_avtal',
    documentVersion: 'v1',
    title: SAMTYCKE_TITLE,
    locale: 'sv-SE',
    meta: META,
    values,
    blocks: [
        ...letterheadAndFooter(SAMTYCKE_TITLE, FORM_NUMBER),
        ...samtyckeSharedBody('samtycke_sarskilda_avtal'),
        {
            instanceId: 'samtycke',
            blockRef: 'samtycke_sarskilda_avtal.samtycke@v1',
            input: { parties: signingPartiesFor(PARTY_SLOTS) },
        },
    ],
});
//# sourceMappingURL=samtycke_sarskilda_avtal.js.map